export default "__VITE_ASSET__yvRsoP_o__"